'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-86/node_modules/@eliadmin/core/src/components/advisory/advisories.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/f6834534d406").then(m => ({ default: m.Advisories })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-86/node_modules/@eliadmin/core/src/components/advisory/advisories.tsx").Advisories>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-86/node_modules/@eliadmin/core/src/components/advisory/advisories.tsx").Advisories;
export { Island0 as Advisories };
